import * as S from './styles'
import IconVisa from '../../../assets/img/pagamento/cartao-visa.svg'
import IconAmex from '../../../assets/img/pagamento/cartao-amex.svg'
import IconMaster from '../../../assets/img/pagamento/cartao-mastercard.svg'
import IconDiners from '../../../assets/img/pagamento/cartao-diners.svg'
import IconElo from '../../../assets/img/pagamento/cartao-elo.svg'
import IconCartao from '../../../assets/img/pagamento/cartao-default.svg'
import IconBoleto from '../../../assets/img/pagamento/boleto.svg'
import IconPix from '../../../assets/img/pagamento/icon-pix.svg'

const CreditCardImage = ({ cartao }) => {
  return (
    <S.CardSvgWrapper>
      {cartao === 'Visa' && <img src={IconVisa} alt="" />}
      {cartao === 'Amex' && <img src={IconAmex} alt="" />}
      {cartao === 'Mastercard' || cartao === 'Master' ? (
        <img src={IconMaster} alt="" />
      ) : null}
      {cartao === 'Diners' && <img src={IconDiners} alt="" />}
      {cartao === 'Elo' && <img src={IconElo} alt="" />}
      {cartao === 'boleto' || cartao === 'Boleto' ? (
        <img src={IconBoleto} alt="" />
      ) : null}{' '}
      {cartao === 'PIX' || cartao === 'Pix' ? (
        <img src={IconPix} alt="" />
      ) : null}
      {!cartao && <img src={IconCartao} alt="" />}
    </S.CardSvgWrapper>
  )
}

export default CreditCardImage
